import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
} from "react-router-dom";
import Homepage3 from "./pages/Homepage3";
import { useEffect } from "react";
import Policy from "./pages/Policy";
import DeepLink from "./pages/DeepLink";
import AppLink from "./pages/AppLink";

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "";
        metaDescription = "";
        break;
      case "/popup-ng-k":
        title = "";
        metaDescription = "";
        break;
      case "/popup-ng-k1":
        title = "";
        metaDescription = "";
        break;
      case "/frame-86869":
        title = "";
        metaDescription = "";
        break;
      case "/popup-gi-tin":
        title = "";
        metaDescription = "";
        break;
      case "/-style-guide-trios":
        title = "";
        metaDescription = "";
        break;
      case "/-style-guide-trios1":
        title = "";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<Homepage3 />} />
      <Route path="/policy.html" element={<Policy />} />
      <Route
        path="/forwardlink"
        element={<DeepLink />}
      />
      <Route
          path="/link/*"
          element={<AppLink />}
      />
    </Routes>
  );
}
export default App;
